import React, { ChangeEventHandler, Component, FocusEventHandler } from 'react';
import { TextField } from '@mui/material';

import { Annotation } from '@paragon/contract-library';

import AnnotationOptionsSection from './AnnotationOptionsSection';

interface Props {
  readonly annotationBeingEdited: Annotation | undefined;
}

interface State {
  readonly rotation: number | string;
}

export default class RotationOptions extends Component<Props, State> {
  state: State = {
    rotation: this.props.annotationBeingEdited ? this.props.annotationBeingEdited.rotation : 0,
  };

  onRotationInputChange: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement> = (event) => {
    this.setState({ rotation: event.target.value });
  };

  onRotationInputBlur: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement> = () => {
    this.setState((prevState) => ({ rotation: (prevState.rotation as number) % 360 || 0 }));
  };

  get updatedProperties() {
    return {
      rotationAngle: parseFloat(this.state.rotation as string),
    };
  }

  render() {
    return (
      <AnnotationOptionsSection title="rotation">
        <TextField
          value={this.state.rotation}
          onBlur={this.onRotationInputBlur}
          onChange={this.onRotationInputChange}
          id="rotationEditInput"
        />
      </AnnotationOptionsSection>
    );
  }
}
